import { render, staticRenderFns } from "./ZhiqiTong4.vue?vue&type=template&id=74b6eb46&scoped=true"
import script from "./ZhiqiTong4.vue?vue&type=script&lang=js"
export * from "./ZhiqiTong4.vue?vue&type=script&lang=js"
import style0 from "./ZhiqiTong4.vue?vue&type=style&index=0&id=74b6eb46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b6eb46",
  null
  
)

export default component.exports